import {
  Box,
  FormControlLabel,
  Radio,
  Typography,
  RadioGroup,
} from "@mui/material";

type Props = {
  currentBlock: any;
};

const RadioField = ({ currentBlock }: Props) => {
  const label = currentBlock?.label;
  const choices = currentBlock?.config?.choices || [];
  const response = currentBlock?.response?.radioKey;

  return (
    <Box>
      {label && (
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: "regular",
            color: "text.primary",
          }}
        >
          {label}
        </Typography>
      )}

      <RadioGroup value={response ?? undefined}>
        {choices.map((choice: any) => (
          <FormControlLabel
            key={choice.key}
            control={<Radio inputProps={{ readOnly: true }} />}
            label={choice.label}
            value={choice.key}
            sx={{
              "& .MuiFormControlLabel-label": {
                fontSize: "16px",
                fontWeight: "medium",
              },
            }}
          />
        ))}
      </RadioGroup>
    </Box>
  );
};

export default RadioField;
